import React from 'react';
import { useHistory } from 'react-router-dom';

export const usePrompt = (when, message = 'Are you sure you want to quit without saving your changes?') => {
  const history = useHistory();
  const self = React.useRef(null);

  function onWindowOrTabClose(event) {
    if (!when) {
      return;
    }

    if (typeof event === 'undefined') {
      event = window.event;
    }

    if (event) {
      event.returnValue = message;
    }

    return message;
  }

  React.useEffect(() => {
    if (when) {
      self.current = history.block(message);
    } else {
      self.current = null;
    }

    window.addEventListener('beforeunload', onWindowOrTabClose);

    return () => {
      if (self.current) {
        self.current();
        self.current = null;
      }

      // Proteger removeEventListener para evitar NotFoundError
      try {
        window.removeEventListener('beforeunload', onWindowOrTabClose);
      } catch (error) {
        console.warn('Error al remover event listener de beforeunload:', error);
      }
    };
  }, [message, when]);
};
